import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { MainGlobalEventService } from '../../../../../../_shared/services/main-global-event.service';
import { CreditorService } from '../../../../../creditor/creditor.service';
import { DocumentTypeService } from '../../../../../document/document-type.service';
import { CaseAssetService } from '../../../../case-asset.service';
import { CaseCreditorService } from '../../../../case-creditor.service';
import {
  BaseDocumentFileUploaderComponent
} from '../base-document-file-uploader/base-document-file-uploader.component';

@Component({
  selector:    'app-case-application-document-list-v3',
  templateUrl: '../base-document-file-uploader/base-document-file-uploader.component.html',
  styleUrls:   ['../base-document-file-uploader/base-document-file-uploader.component.scss'],
  standalone:  false
})
export class CaseApplicationDocumentListV3Component extends BaseDocumentFileUploaderComponent implements OnInit, OnDestroy {

  public isUserLawyer           = false;
  public isUserCourtNotificator = false;
  public isUserCaseManager      = false;

  constructor(
    protected fb: FormBuilder,
    protected dialog: MatDialog,
    protected toastr: ToastrService,
    protected cookieService: CookieService,
    protected translate: TranslateService,
    protected globalEventsService: MainGlobalEventService,
    protected documentTypeService: DocumentTypeService,
    protected caseCreditorService: CaseCreditorService,
    protected caseAssetService: CaseAssetService,
    protected creditorService: CreditorService,
  ) {
    super(
      fb,
      dialog,
      toastr,
      cookieService,
      translate,
      globalEventsService,
      documentTypeService,
      caseCreditorService,
      caseAssetService,
      creditorService,
    );
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.subscriptions.push(
      this.globalEventsService.authUser$.subscribe({
        next:  user => {
          this.authUser = user;
          this.authUser.departments.forEach(department => {
            if (department.type === 'lawyer') {
              this.isUserLawyer = true;
            } else if (department.type === 'court-notificator') {
              this.isUserCourtNotificator = true;
            } else if (department?.type === 'case-manager') {
              this.isUserCaseManager = true;
            }
          });
        },
        error: err => console.error(err),
      })
    );

    const requestData: any = {
      types:              ['client_case_application_custom'],
      show_unrequestable: true
    };
    if (this.appEnv === 'local' || this.isUserCaseManager || this.isUserLawyer || this.isUserCourtNotificator) {
      requestData.types.push('client_case_generated_documents');
    }
    const relations = ['document_types', 'document_types.documents'];

    if (this.documentableType && this.documentableId) {
      requestData.documentable_type = this.documentableType;
      requestData.documentable_id   = this.documentableId;
    }

    this.fetchDocumentTypeCategories(this.case, requestData, relations);
  }

}
